import React, { useState } from 'react';
import { HelpText, Label, Text } from '@gjensidige/builders-components';
import tracker  from '../../tracking.js';

interface EnquiryOptionImmutableProps {
  labelText: string;
  helpText?: string;
  selectedValue: string;
  referenceId?: string;
}
export const EnquiryOptionImmutable: React.FC<EnquiryOptionImmutableProps> = ({
  labelText,
  helpText,
  selectedValue,
  referenceId=''
}) => {
  const {scenario_name, scenario_step} = tracker.getOptions();
  const [isToggled, setIsToggled] = useState(false);

  return (
    <>
    <Label className="enquiry-text-box-label" htmlFor={referenceId}>
      {labelText}
    </Label>
    <HelpText
        children={helpText}
        toggle={isToggled ? `Stäng hjälptext för ${labelText}` : `Visa hjälptext för ${labelText}`}
        open={isToggled}
        onToggle={() => setIsToggled(!isToggled)}
        tracking={{
          // @ts-expect-error
          scenario_name,
          scenario_step,
          eventLabel: labelText
        }}
        className="help-text-immutable"
        htmlFor={referenceId}
      />
      <Text size='body' id={referenceId}>{selectedValue}</Text>
    </>
  )
  
};
